import React, { useState, useRef, useEffect } from "react";
import QRCode from "qrcode.react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { planSubmitEndpoint } from '../../../endpoint';
import { getEnvironmentEndpoint } from '../../../utils/getEnvironmentEndpoint';
import { AnswerEstimate } from '../../../types/planModel';

import styles from "./Tab.module.scss";
import global from '../../../styles/index.module.scss';

import Modal from './Modal';

import imgStore from "../../../assets/img/plan/img_store.png";
import imgRepair from "../../../assets/img/plan/img_repair.png";
import IconBottomArrow from "../../../assets/img/common/icon_bottom_arrow.svg";
import IconFactory from "../../../assets/img/common/icon_factory.svg";
import IconPrice from "../../../assets/img/common/icon_price.svg";
import { Layout } from "../../../components/common/Layout/Layout";

// TabProps インターフェースを定義
interface TabProps {
  activeTab: "store" | "repairCenter";
  data: AnswerEstimate[];
  contactUrl: string | undefined;
}

export const Tab: React.FC<TabProps> = ({ activeTab, data, contactUrl }) => {
  const [activeTabState, setActiveTabState] = useState<"store" | "repairCenter">(activeTab);
  const [openAccordion, setOpenAccordion] = useState<number | null>(0);
  const [selectedPlan, setSelectedPlan] = useState<number>(0); 
  const [isLoading, setIsLoading] = useState(false);
  // const [isChecked, setIsChecked] = useState(false);
  const [isKiyakuChecked, setIsKiyakuChecked] = useState(false);
  const [isPriceChecked, setIsPriceChecked] = useState(false);
  const [isSnsChecked, setIsSnsChecked] = useState(false);
  const [isOkinawaChecked, setIsOkinawaChecked] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageUrl, setCurrentImageUrl] = useState('');

  

  const navigate = useNavigate();

  const generateStoreAccordionData = (data: AnswerEstimate[]) => {
    return data[0].proposal_plans_store.map((plan) => ({
      header: plan.plan_title,
      content: (
        <div className={styles.repairMenu}>
          <h4 className={styles.headingLv4}>修理メニュー</h4>
          {plan.repair_menus.map((repair, optionIndex) => (
            <div className={styles.repairMenuContent} key={optionIndex}>
              <div className={styles.repairMenuContentUpper}>
                <picture className={styles.repairMenuImg}>
                  <img
                    src={repair.image_url}
                    alt="修理メニューの画像"
                    width={64}
                    height={64}
                    onClick={() => openModal(repair.image_url)}
                    style={{ cursor: 'pointer' }}
                  />
                </picture>
                <p className={styles.repairMenuTitle}>{repair.title}</p>
              </div>
              <ul className={styles.repairMenuList}>
                <li className={styles.repairMenuItem}>
                  <div className={styles.repairMenuItemIcon}>
                    <IconPrice />
                  </div>
                  <p className={styles.repairMenuItemTitle}>見積もり金額</p>
                  <p className={styles.repairMenuItemValue}>{repair.price}</p>
                </li>
                <li className={styles.repairMenuItem}>
                  <div className={styles.repairMenuItemIcon}>
                    <IconFactory />
                  </div>
                  <p className={styles.repairMenuItemTitle}>納期(店舗修理)</p>
                  <p className={styles.repairMenuItemValue}>{repair.delivery_time}※正確な納期はご注文確定時に再度ご提示いたします。</p>
                </li>
              </ul>
              <p className={styles.menuDescription}>
                {repair.description}
              </p>
            </div>
          ))}
          {
            plan.options.length > 0 &&
            <>
              <div className={styles.optionHeader}>
                <h4 className={styles.headingLv4}>オプション</h4>
              </div>
              <div className={styles.optionContainer}>
                {plan.options.map((option, optionIndex) => (
                  <div className={styles.repairOption} key={optionIndex}>
                    <div className={styles.optionLabel}>
                      <div className={styles.repairMenuContentUpper}>
                        <picture className={styles.repairMenuImg}>
                          <img src={option.image_url} alt="オプションメニューの画像" width={64} height={64} onClick={() => openModal(option.image_url)} style={{ cursor: 'pointer' }}/>
                        </picture>
                        <p className={styles.repairMenuTitle}>{option.title}</p>
                      </div>
                      <div className={styles.repairDetailsContainer}>
                        <ul className={styles.repairMenuList}>
                          <li className={styles.repairMenuItem}>
                            <div className={styles.repairMenuItemIcon}>
                              <IconPrice />
                            </div>
                            <p className={styles.repairMenuItemTitle}>見積もり金額</p>
                            <p className={styles.repairMenuItemValue}>{option.price}</p>
                          </li>
                          {
                            option.delivery_time &&
                            <li className={styles.repairMenuItem}>
                              <div className={styles.repairMenuItemIcon}>
                                <IconFactory />
                              </div>
                              <p className={styles.repairMenuItemTitle}>納期(店舗修理)</p>
                              <p className={styles.repairMenuItemValue}>{option.delivery_time}※正確な納期はご注文確定時に再度ご提示いたします。</p>
                            </li>
                          }
                        </ul>
                      </div>
                      <p className={styles.menuDescription}>{option.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          }
        </div>
      ),
    }));
  };

  const storeAccordionData = data ? generateStoreAccordionData(data) : [];

  const generateRepairCenterAccordionData = (data: AnswerEstimate[]) => {
    return data[0].proposal_plans_delivery.map((plan) => ({
      header: plan.plan_title,
      content: (planIndex: number) => (
        <div className={styles.repairMenu}>
          <h4 className={styles.headingLv4}>修理メニュー</h4>
          {plan.repair_menus.map((repair, repairIndex) => (
            <div className={styles.repairMenuContent} key={repairIndex}>
              <div className={styles.repairMenuContentUpper}>
                <picture className={styles.repairMenuImg}>
                  <img src={repair.image_url} alt="修理メニューの画像" onClick={() => openModal(repair.image_url)} style={{ cursor: 'pointer' }}/>
                </picture>
                <p className={styles.repairMenuTitle}>{repair.title}</p>
              </div>
              <ul className={styles.repairMenuList}>
                <li className={styles.repairMenuItem}>
                  <div className={styles.repairMenuItemIcon}>
                    <IconPrice />
                  </div>
                  <p className={styles.repairMenuItemTitle}>見積もり金額</p>
                  <p className={styles.repairMenuItemValue}>{repair.price}</p>
                </li>
                <li className={styles.repairMenuItem}>
                  <div className={styles.repairMenuItemIcon}>
                    <IconFactory />
                  </div>
                  <p className={styles.repairMenuItemTitle}>納期(配送修理)</p>
                  <p className={styles.repairMenuItemValue}>{repair.delivery_time}※正確な納期はご注文確定時に再度ご提示いたします。</p>
                </li>
              </ul>
              <p className={styles.menuDescription}>{repair.description}</p>
            </div>
          ))}
          {
            plan.options.length > 0 &&
            <>
              <div className={styles.optionHeader}>
                <h4 className={styles.headingLv4}>オプション</h4>
                <p className={styles.optionNote}>※複数選択可能</p>
              </div>
              <div className={styles.optionContainer}>
                {plan.options.map((option, optionIndex) => (
                  <div className={styles.repairOption} key={optionIndex}>
                    <input
                      type="checkbox"
                      id={`option${optionIndex}-${planIndex}`}
                      className={styles.optionCheckbox}
                      checked={selectedOptions[planIndex]?.includes(optionIndex) || false}
                      onChange={() => handleOptionChange(planIndex, optionIndex)}
                      aria-labelledby={`option${optionIndex}-label-${planIndex}`}
                    />
                    <div id={`option${optionIndex}-label-${planIndex}`} className={styles.optionLabel}>
                      {/* <p className={styles.optionTitle}>{option.title}</p> */}
                      <div className={styles.repairMenuContentUpper}>
                        <picture className={styles.repairMenuImg}>
                          <img
                            src={option.image_url}
                            alt="オプションメニューの画像"
                            width={64}
                            height={64}
                            onClick={() => openModal(option.image_url)}
                            style={{ cursor: 'pointer' }}
                          />
                        </picture>
                        <p className={styles.repairMenuTitle}>{option.title}</p>
                      </div>
                      <div className={styles.repairDetailsContainer}>
                        <ul className={styles.repairMenuList}>
                          <li className={styles.repairMenuItem}>
                            <div className={styles.repairMenuItemIcon}>
                              <IconPrice />
                            </div>
                            <p className={styles.repairMenuItemTitle}>見積もり金額</p>
                            <p className={styles.repairMenuItemValue}>{option.price}</p>
                          </li>
                          {
                            option.delivery_time &&
                            <li className={styles.repairMenuItem}>
                              <div className={styles.repairMenuItemIcon}>
                                <IconFactory />
                              </div>
                              <p className={styles.repairMenuItemTitle}>納期(配送修理)</p>
                              <p className={styles.repairMenuItemValue}>{option.delivery_time}※正確な納期はご注文確定時に再度ご提示いたします。</p>
                            </li>
                          }
                        </ul>
                      </div>
                      <p className={styles.menuDescription}>{option.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          }
        </div>
      ),
    }));
  };

  const repairCenterAccordionData = data ? generateRepairCenterAccordionData(data) : [];

  

  const [selectedOptions, setSelectedOptions] = useState<{ [key: number]: number[] }>({});
  const [heights, setHeights] = useState<number[]>([]);

  const contentRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    if (selectedPlan !== null) {
      setOpenAccordion(selectedPlan);
    }
  }, [selectedPlan]);

  const toggleAccordion = (index: number) => {
    setOpenAccordion(openAccordion === index ? null : index);
    if (openAccordion !== index) {
      setSelectedPlan(index);
    }
  };

  const handleTabChange = (tab: "store" | "repairCenter") => {
    setActiveTabState(tab);
    setOpenAccordion(0); // タブを変更した際にアコーディオンを閉じる
    setHeights([]); // 高さをリセット
    if (tab === "repairCenter") {
      setSelectedPlan(0); // リペアセンタータブを選択した際に選択を一番上にリセット
    }
  };

  const handlePlanChange = (index: number) => {
    setSelectedPlan(index);
    setOpenAccordion(index); // ラジオボタンが押されたときにアコーディオンを開く
  };

  const handleOptionChange = (planIndex: number, optionIndex: number) => {
    setSelectedOptions((prev) => {
      const currentOptions = prev[planIndex] || [];
      const newOptions = currentOptions.includes(optionIndex)
        ? currentOptions.filter((opt) => opt !== optionIndex)
        : [...currentOptions, optionIndex];
      return { ...prev, [planIndex]: newOptions };
    });
  };

  const openModal = (imageUrl: string) => {
    setCurrentImageUrl(imageUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImageUrl('');
  };

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden'; // スクロールを無効にする
    } else {
      document.body.style.overflow = ''; // スクロールを有効にする
    }

    return () => {
      document.body.style.overflow = ''; // クリーンアップ
    };
  }, [isModalOpen]);

  const handleKiyakuChange = () => {
    setIsKiyakuChecked(!isKiyakuChecked);
  };

  const handlePriceChange = () => {
    setIsPriceChecked(!isPriceChecked);
  };

  const handleSnsChange = () => {
    setIsSnsChecked(!isSnsChecked);
  };

  const handleOkinawaChange = () => {
    setIsOkinawaChecked(!isOkinawaChecked);
  };

  // 沖縄のチェックボックス以外ががチェックされているかを確認
  const allChecked = isKiyakuChecked && isPriceChecked;

  const getSelectedPlanData = () => {
    if (!data || data.length === 0) {
      throw new Error('データが存在しません');
    }

    const selectedPlanData = data[0].proposal_plans_delivery[selectedPlan];
    const selectedPlanOptions = selectedOptions[selectedPlan]?.map(optionIndex => selectedPlanData.options[optionIndex]) || [];
    console.log(selectedPlanData);
    console.log(selectedPlanOptions);

    return {
      event: "registOrder",
      payload: {
        id: data[0].id,
        okinawa_is_checked: isOkinawaChecked,
        sns_agree_is_checked: isSnsChecked,
        proposal_plans: [
          {
            ...selectedPlanData,
            options: selectedPlanOptions
          }
        ]
      }
    };
  };

  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (data && data.length > 0) {
      const newHeights = contentRefs.current.map((ref) => ref?.scrollHeight || 0);
      setHeights(newHeights);
      setIsDataLoaded(true);
    }
  }, [data]);

  useEffect(() => {
    if (isDataLoaded) {
      const newHeights = contentRefs.current.map((ref) => ref?.scrollHeight || 0);
      setHeights(newHeights);
    }
  }, [openAccordion]);

  const onSubmit = async () => {
    setIsLoading(true);
    try {
      const jsonData = getSelectedPlanData();
      console.log(jsonData);
      // JSONデータを表示（デバッグ用）
      console.log('送信データ:', JSON.stringify(jsonData, null, 2))
      const endpoint = getEnvironmentEndpoint(planSubmitEndpoint);
      // axiosを使用してデータを送信
      const response = await axios.post(
        endpoint,
        jsonData,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('送信成功:', response.data);
      navigate('/pages/plan/complete');
    } catch (error) {
      console.error('送信エラー:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // if (isComplete) {
  //   return <Complete />;
  // }

  const hasBothRepairMenus = data[0].proposal_plans_delivery.some(plan => plan.repair_menus.length > 0) && data[0].proposal_plans_store.some(plan => plan.repair_menus.length > 0);
  const hasStoreRepairMenus = data[0].proposal_plans_store.some(plan => plan.repair_menus.length > 0);
  const hasDeliveryRepairMenus = data[0].proposal_plans_delivery.some(plan => plan.repair_menus.length > 0);

  console.log('hasBothRepairMenus:', hasBothRepairMenus);
console.log('hasStoreRepairMenus:', hasStoreRepairMenus);
console.log('hasDeliveryRepairMenus:', hasDeliveryRepairMenus);

  return (
    <div className={styles.menuWrapper}>
      {
        hasBothRepairMenus && (
          <div className={styles.tabs} role="tablist">
            <button
              className={`${styles.tab} ${"js-trackEvent"} ${activeTabState === "store" ? styles.active : ""}`}
              onClick={() => handleTabChange("store")}
              role="tab"
              aria-selected={activeTabState === "store"}
              aria-controls="store-panel"
              id="store-tab"
              data-ga-id="Clik_Btn_Plan_Tab_Store"
            >
              <span>店舗で修理</span>
            </button>
            <button
              className={`${styles.tab} ${"js-trackEvent"} ${activeTabState === "repairCenter" ? styles.active : ""}`}
              onClick={() => handleTabChange("repairCenter")}
              role="tab"
              aria-selected={activeTabState === "repairCenter"}
              aria-controls="repairCenter-panel"
              id="repairCenter-tab"
              data-ga-id="Clik_Btn_Plan_Tab_RepaireCenter"
            >
              <span>配送で修理</span>
            </button>
          </div>
        )
      }
      { (hasStoreRepairMenus && (!hasBothRepairMenus || activeTabState === "store")) && (
        <div
          className={styles.content}
          id="store-panel"
          role="tabpanel"
          aria-labelledby="store-tab"
          hidden={hasBothRepairMenus && activeTabState !== "store"}
        >
          <div className={styles.contentTitleWrapper}>
            <h3 className={styles.headingLv3}>ご提案メニュー</h3>
            <p className={styles.contentTitle}>ご要望に近いものを選択してください</p>
          </div>

          <div className={styles.accordionWrapper}>
            {storeAccordionData.map((item, index) => (
              <div key={index} className={styles.accordion}>
                <button
                  className={`${styles.accordionHeader} ${styles.borderNone}`}
                  onClick={() => toggleAccordion(index)}
                  aria-expanded={openAccordion === index}
                  aria-controls={`accordion-content-${index}`}
                  id={`accordion-header-${index}`}
                >
                  <span className={styles.buttonLabel}>{`提案${index + 1}`}</span>{item.header}
                  <span className={styles.iconBottomArrow}>
                    <IconBottomArrow />
                  </span>
                </button>
                <div
                  className={`${styles.accordionContent} ${openAccordion === index ? styles.isOpened : ""}`}
                  ref={(el) => (contentRefs.current[index] = el)}
                  id={`accordion-content-${index}`}
                  role="region"
                  aria-labelledby={`accordion-header-${index}`}
                  style={{
                    height: openAccordion === index ? `${heights[index]}px` : "0px",
                    overflow: "hidden",
                    transition: "height 0.3s ease",
                  }}
                >
                  <div className={styles.contentInner}>{item.content}</div>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.storeImg}>
            <img src={imgStore} alt="店舗に持っていくイラスト" width={190} height={172} />
          </div>
          <p className={styles.text}>ご依頼いただく場合は<br />店舗に修理品をお持ちください。<br /><br />状態に合わせたご提案をいたしますため、<br />修理品の状態によってはご提案・お見積り金額が<br />異なる場合があります。<br />あらかじめご了承ください。</p>
          {
            data[0].qr_code_url && (
              <div className={styles.qrContent}>
                <h3 className={styles.headingLv3}>店舗でこちらのQRコードを<br />ご提示ください</h3>
                <div className={styles.qrTextWrapper}>
                  <p className={styles.qrText}>
                    店舗スタッフにはお見積りの内容は<br />事前に伝わっておりません。<br />ご来店の際はこの二次元バーコードをご提示ください。
                  </p>
                </div>
                <div className={styles.qrCodeWrapper}>
                  <div className={styles.qrCode}>
                    <QRCode value={data[0].qr_code_url} size={155} />
                  </div>
                </div>
              </div>
            )
          }
          {
            data[0].store_link && (
              <a href={data[0].store_link} className={`${styles.findStoreButton} ${styles.borderNone}`} data-ga-id="Clik_Btn_Plen_Seach_Store">
                店舗を探す
              </a>
            )
          }
          <div className={styles.contactArea}>
            <p className={styles.contactText}>こちらの返信は以下のボタンからお願いいたします。</p>
            <div className={global.buttonWrapper}>
              <a href={contactUrl} className={global.primaryButton}>返信する</a>
            </div>
          </div>
        </div>
      )}
      {(hasDeliveryRepairMenus && (!hasBothRepairMenus || activeTabState === "repairCenter")) && (
        <div
          className={`${styles.content} ${styles.repairCenterContent}`}
          id="repairCenter-panel"
          role="tabpanel"
          aria-labelledby="repairCenter-tab"
          hidden={hasBothRepairMenus && activeTabState !== "repairCenter"}
        >
          <h3 className={styles.headingLv3}>ご提案プラン</h3>
          <div className={styles.contentSubtitleWrapper}>
            <p className={styles.contentSubtitle}>
              配送修理をお申し込みになる場合は、ご希望のプランにチェックを入れ、下にある「配送修理を申し込む」ボタンを押してください。
              <br />
              <span className="u-font-bold">※送料について必ずご確認ください。</span>
            </p>
          </div>
          <div className={styles.accordionWrapper}>
            {repairCenterAccordionData.map((item, index) => (
              <div
                key={index}
                className={`${styles.accordion} ${openAccordion === index ? styles.isActive : ""}`}
              >
                <div className={styles.customRadio}>
                  <input
                    type="radio"
                    name="repair-plan"
                    id={`repair-plan-${index}`}
                    checked={selectedPlan === index}
                    onChange={() => handlePlanChange(index)}
                    aria-labelledby={`repair-plan-label-${index}`}
                  />
                  <label htmlFor={`repair-plan-${index}`}>
                    <button
                      className={styles.accordionHeader}
                      onClick={() => toggleAccordion(index)}
                      aria-expanded={openAccordion === index}
                      aria-controls={`accordion-content-${index}`}
                      id={`accordion-header-${index}`}
                    >
                      <span className={styles.buttonLabel}>{`提案${index + 1}`}</span>{item.header}
                      <span className={styles.iconBottomArrow}>
                        <IconBottomArrow />
                      </span>
                    </button>
                  </label>
                </div>
                <div
                  className={`${styles.accordionContent} ${openAccordion === index ? styles.isOpened : ""}`}
                  ref={(el) => (contentRefs.current[index] = el)}
                  id={`accordion-content-${index}`}
                  role="region"
                  aria-labelledby={`accordion-header-${index}`}
                  style={{
                    height: openAccordion === index ? `${heights[index]}px` : "0px",
                    overflow: "hidden",
                    transition: "height 0.3s ease",
                  }}
                >
                  <div className={styles.contentInner}>{item.content(index)}</div>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.orderSection}>
            <div className={styles.repairImg}>
              <img src={imgRepair} alt="リペアのイメージイラスト" width={190} height={172} />
            </div>
            <p className={styles.contentText}>
              <br aria-hidden="true" />
              <span>送付の送料（お客様→ リペアセンター）</span>
              <br aria-hidden="true" />
              ・修理依頼時に修理品をお送りいただく送料は、<span>発払い（お客様ご負担）です。</span>
              <br aria-hidden="true" />
              ・ 着払いでお送りいただいた場合は、修理金額と合わせてご請求いたします。
              <br aria-hidden="true" />
              <br aria-hidden="true" />
              <span>返送の送料（リペアセンター→お客様）</span>
              <br aria-hidden="true" />
              ・修理完了後にお戻しする返送時の送料です。
              <br aria-hidden="true" />
              ・お申し込みいただく修理のご利用金額によって、返送料が発生します。修理金額の確定時に合わせてご請求いたします。
            </p>
            <Layout>
              <div className={global.tableFlex}>
                <div>
                  <h4 className={global.headingLv4}>靴・スニーカー・バッグ・かさなど（スーツケース以外）</h4>
                  <div className={global.tableContainer}>
                    <table className={`${global.shippingTable} ${global.isPlan}`}>
                      <tbody>
                        <tr>
                          <th>3,300円(税込)以上</th>
                          <td>無料</td>
                        </tr>
                        <tr>
                          <th>3,300円(税込)未満</th>
                          <td>880円(税込)</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p className={global.tableCautionText}>沖縄県への場合は、梱包サイズに応じた返送料をご請求いたします。（ヤマト運輸宅急便の料金表に準じます)</p>
                  <a href='https://www.kuronekoyamato.co.jp/ytc/search/estimate/okinawa.html' target="_blank" className={global.tableLinkText}>https://www.kuronekoyamato.co.jp/ytc/search/estimate/okinawa.html</a>
                </div>
                <div>
                  <h4 className={global.headingLv4}>スーツケース<br className="u-dsp-pc"/><br className="u-dsp-pc"/></h4>
                  <div className={global.tableContainer}>
                    <table className={`${global.shippingTable} ${global.isPlan}`}>
                      <tbody>
                        <tr>
                          <th>一律</th>
                          <td>1,650円（税込）</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p className={global.tableCautionText}>沖縄県への場合は、梱包サイズに応じた返送料をご請求いたします。（ヤマト運輸宅急便の料金表に準じます)</p>
                  <a href='https://www.kuronekoyamato.co.jp/ytc/search/estimate/okinawa.html' target="_blank" className={global.tableLinkText}>https://www.kuronekoyamato.co.jp/ytc/search/estimate/okinawa.html</a>
                </div>
                
              </div>
            </Layout>
            <Layout>
              <div className={styles.checkbox}>
                <input
                  type="checkbox"
                  id="kiyaku"
                  className={styles.checkboxInput}
                  aria-labelledby="kiyaku-label"
                  checked={isKiyakuChecked}
                  onChange={handleKiyakuChange}
                />
                <label htmlFor="kiyaku" id="kiyaku-label" className={styles.checkboxLabel}>
                  <a href="/policies/terms-of-service" target="_blank">利用規約</a>
                  に同意する（必須）
                </label>
              </div>
              <div className={styles.checkbox}>
                <input
                  type="checkbox"
                  id="price"
                  className={styles.checkboxInput}
                  aria-labelledby="price-label"
                  checked={isPriceChecked}
                  onChange={handlePriceChange}
                />
                <label htmlFor="price" id="price-label" className={styles.checkboxLabel}>
                現在ご提示している金額は画像見積もりによる結果です。最終の修理金額はお送りいただく現物と照合した後で確定するため、金額が変更される場合があることを理解した上で申し込みます。（必須）
                </label>
              </div>
              <div className={styles.checkbox}>
                <input
                  type="checkbox"
                  id="sns"
                  className={styles.checkboxInput}
                  aria-labelledby="sns-label"
                  checked={isSnsChecked}
                  onChange={handleSnsChange}
                />
                <label htmlFor="sns" id="sns-label" className={styles.checkboxLabel}>
                ご依頼の修理品を、当社で宣伝を目的とし写真・動画を撮影し、​​当社WEBサイト・SNS等でコンテンツとして利用することに同意します。（任意）
                </label>
              </div>
              <div className={styles.okinawaCheckboxWrapper}>
                <p className={styles.okinawaCheckboxTitle}>◆沖縄県への返送を希望される方のみご回答ください</p>
                <div className={styles.checkbox}>
                  <input
                    type="checkbox"
                    id="okinawa"
                    className={styles.checkboxInput}
                    aria-labelledby="okinawa-label"
                    checked={isOkinawaChecked}
                    onChange={handleOkinawaChange}
                  />
                  <label htmlFor="okinawa" id="okinawa-label" className={styles.checkboxLabel}>
                    <span><strong>「沖縄県」への返送を希望する場合はチェックを入れてください。</strong></span>梱包サイズに応じた配送料をご請求します。（任意）
                  </label>
                </div>
              </div>
            </Layout>
            <p className={styles.choosePlanNumber}>提案{selectedPlan + 1}選択中</p>
            <div className={global.buttonWrapper}>
              <button data-ga-id="Clik_Btn_Plen_Seach_Preorder" className={`${global.primaryButton} ${"js-trackEvent"} ${!allChecked ? global.disabled : ''} ${isLoading ? global.disabled : ''}` } disabled={!allChecked || isLoading} onClick={() => void onSubmit()}>{isLoading ? '送信中...' : '配送修理を申し込む'}</button>
            </div>
          </div>
          <div className={styles.contactArea}>
            <h3 className={styles.headingLv3}>お申し込みの前に<br />不明点や質問などある方は<br />以下よりご連絡下さい</h3>
            <div className={global.buttonWrapper}>
              <a href={contactUrl} className={global.primaryButton}>連絡する</a>
            </div>
          </div>
        </div>
      )}
      <Modal isOpen={isModalOpen} imageUrl={currentImageUrl} onClose={closeModal} />
    </div>
  );
};
